import type { ReactNode } from 'react';


// Minimal admin auth card. Public landing pages are intentionally absent —
// the admin app is not meant to be crawlable or discoverable.
export function AuthCard({ children }: { children: ReactNode }) {
  return (
    <div className="mx-auto flex min-h-screen items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="rounded-2xl border border-gray-200 bg-white p-8 shadow-card">
          <div className="flex flex-col items-center">
            <img src="/ecregi_logo.png" alt="EcRegi" className="h-16 w-16" />

          </div>
          <div className="mt-6">{children}</div>
        </div>
        <p className="mt-4 text-center text-[11px] text-gray-500">
          Restricted access. Unauthorized use is prohibited and logged.
        </p>
      </div>
    </div>
  );
}
